import { NgModule } from 'ng-metadata/core';
import {AddQueryToSavedSearchesService} from './addQueryToSavedSearches/addQueryToSavedSearches.service';
import {PrmEditNotificationSettings} from './editNotificationSettings/editNotificationSettings.directive';
import {PrmAddAlertToast} from './addAlertToast/addAlertToast.directive';
import {PrmAddQueryToSavedSearches} from './addQueryToSavedSearches/addQueryToSavedSearches.directive';

@NgModule({
    declarations: [
        PrmAddAlertToast,
        PrmEditNotificationSettings,
        PrmAddQueryToSavedSearches
    ],
    providers: [
        AddQueryToSavedSearchesService
    ],
    imports:[
    ]
})
export class SearchSavedQueriesModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/savedQueries/searchSavedQueries.module.ts